export default __webpack_public_path__ + "static/media/LOGO PARKEO.fa15d1fe.png";